import { iconsSet } from "../../../../assets/icons/icons";
// import defaultContent from "../default";
export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_velocash.png",
      alt: "Velo Cash",
    },
    title: "Lucre com a Velo Cash",

    // String ou array de strings
    text: "Nosso foco é entregar resultados. As soluções da Velo Cash são projetadas para maximizar os ganhos e minimizar os riscos, proporcionando uma experiência confiável e lucrativa a longo prazo.",
    testimonial: {
      text: "Sempre em busca de ter lucro no mercado financeiro",
      author: {
        name: "Caroline Castro – Criadora de estratégias Velo Cash",
        // picture: "",
      },
    },
  },

  strategies: {
    title: "Estratégias Velo Cash",
    heading: "Conheça nossas estratégias! ",
    subtitle: "Estamos comprometidos em oferecer uma experiência excepcional. ",
  },

  cta: {
    title: "Quer lucrar como profissional? ",
    subtitle: "Ative agora mesmo a extensão Velo Cash",
  },

  about: {
    title: "Sobre o desenvolvedor",
    subtitle: "Velo Cash",
    col1: [
      "Somos uma empresa jovem com pouco mais de 2 anos de experiência no mercado, e entendemos que o mercado financeiro é complexo. Por isso criamos a Velo Cash, permitindo que cada investidor tenha consistência nas operações. ",
    ],
    col2: [
      // "",
    ],
  },

  stats: {
    title: "Números da Velo Cash",
    subtitle: "Convidamos você a fazer parte dessa evolução",
    data: [
      {
        value: "+1k",
        description: "Clientes",
      },
      {
        value: "+2",
        description: "Anos de experiência",
      },
      {
        value: "+10",
        description: "Estratégias",
      },
    ],
  },

  // picture: {
  //   url: "https://ontick-img.s3.sa-east-1.amazonaws.com/nl_resultado.jpeg",
  //   description: "Algoritmo de Mini-índice x Ibovespa. Atualizado em 12 de setembro de 2022.",
  // },

  features: {
    title: "Por que utilizar os meus robôs?",
    subtitle: "Veja quais as principais vantagens.",
    data: [
      {
        icon: iconsSet.code,
        title: "100% automatizado",
        description:
          "Desenvolvemos soluções automatizadas que utilizam as mais recentes tecnologias em inteligência artificial. ",
      },
      {
        icon: iconsSet.chat_round,
        title: "Suporte",
        description:
          "Oferecemos suporte contínuo para ajudar nossos clientes a entenderem e utilizarem nossas estratégias de forma eficaz. ",
      },
      {
        icon: iconsSet.sparkle,
        title: "Cliente",
        description:
          "Estamos comprometidos em oferecer uma experiência excepcional para garantir a satisfação dos nossos clientes. ",
      },
      {
        icon: iconsSet.favorite,
        title: "Sem emocional",
        description:
          "A falta de consistência do trader é o emocional, com as nossas estratégias você não precisa se preocupar com nada. ",
      },
      {
        icon: iconsSet.hourglass,
        title: "Tempo",
        description: "Nosso foco é entregar resultados de forma confiável no longo prazo. ",
      },
      {
        icon: iconsSet.calendar,
        title: "7 dias para testar",
        description: "Você pode testar nossas estratégias e conferir os resultados em sua conta. ",
      },
      // ...defaultContent.features.data,
    ],
  },

  testimonials: [
    {
      text: "Com a Velocash, consegui melhorar significativamente meu desempenho como investidor. As ferramentas são fáceis de usar e realmente fazem a diferença.",
      author: "João Silva",
      job: "Advogado",
      // image_url:
      //   "https://ontick-img.s3.sa-east-1.amazonaws.com/flavio-rezende.png",
    },
    {
      text: "Finalmente encontrei uma solução que entende minhas necessidades. As estratégias da Velocash são simplesmente excelentes.",
      author: "Mário de Oliveira",
      job: "Empresário",
      // image_url:
      //   "https://ontick-img.s3.sa-east-1.amazonaws.com/david-souza.png",
    },
  ],

  plans: {
    title: "Planos",
    subtitle: "Escolha o plano mais adequado para você:",
  },
};

// https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_algotrading.png
